var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-option",class:{'is-selected': _vm.isSelected},on:{"click":function($event){return _vm.$emit('clicked', _vm.option)}}},[_c('p',{staticClass:"option-text"},[_vm._v(_vm._s(_vm.option.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }